import StatusComponent from '@Components/Status'
import React from 'react'
import {
    getOverclaimStatusText,
    getOverclaimToolTip,
    OverclaimFilterStatus,
} from '@App/helpers/work-entities/utils/overclaim_filter_status_helper'

interface OverclaimStatusIndicatorProps {
    overclaimStatus: OverclaimFilterStatus
    count?: number
    withCount?: boolean
}

const OverclaimStatusIndicator = (props: OverclaimStatusIndicatorProps) => {
    const { overclaimStatus, count, withCount } = props
    const status = getOverclaimStatusText(overclaimStatus)
    return (
        status && (
            <StatusComponent
                withCount={!!withCount}
                status={status}
                count={count}
                circleFirst
                tooltip={getOverclaimToolTip(overclaimStatus)}
            />
        )
    )
}
export default OverclaimStatusIndicator
